import Vue from 'vue';
import lodash from 'lodash';
import VueLodash from 'vue-lodash/dist/vue-lodash.min';

Vue.use(VueLodash, lodash);



// WEBPACK FOOTER //
// ./src/plugins/lodash/index.js